module.exports = __webpack_public_path__ + "bcn-baby.jpg?eccf57755c20c3328dba7e4fae6c2602";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/bcn-baby.jpg
// module id = 108
// module chunks = 0